// How a role is named on screen; the API keeps the codes.
export const ROLE_LABEL = {
  owner: "Owner",
  admin_fped: "Admin FPED",
  partner_operator: "Partener (operator)",
  viewer: "Viewer",
  admin: "Admin FPED", // legacy fallback
};

export const roleLabel = (role) => ROLE_LABEL[role] || role || "";
